import { render, staticRenderFns } from "./SignatureWarning.vue?vue&type=template&id=24001028"
import script from "./SignatureWarning.vue?vue&type=script&lang=js"
export * from "./SignatureWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports